<template>
  <div id="OtherProductName" class="OtherProductName">
          <div class="row OtherProductNameBody"> 
              <div class="OtherProductName_nav" 
              v-for="(item, index) in temp_Value" 
              :key="index" 
              >
                <div class="OtherProductName_block">
                    <div class="col-12">
                             <textbox 
                                :ControlId="'nameE_'+index" 
                                :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_OtherEn')" 
                                type="text"
                                CharLimit="CheckEnglishChar"
                                :maxLength="300"  
                                v-model="item.nameE"
                                >
                            </textbox>
                        <ProductFieldApprovalResults
                          usage-type="ExhibitOtherNameE"
                          :usage-id="otherNameRid(item, 'E')"
                        />
                    </div>
                    <div class="col-12">
                          <textbox 
                                :ControlId="'nameT_'+index" 
                                :title="$t('lbl_EMPBE_ProductInfo_BasicInfo_ProductName_OtherCn')" 
                                type="text"
                                :maxLength="300"  
                                v-model="item.nameT">
                            </textbox>
                        <ProductFieldApprovalResults
                          usage-type="ExhibitOtherNameS"
                          :usage-id="otherNameRid(item, 'T')"
                        />
                    </div>
                </div>
                <div >
                  <img :src="cdnURL+'DelSale_Enquiry.svg'" @click="DelOtherProductName(index)"/>
                </div>
              </div>
          </div>
           <b-button  v-if="temp_Value.length<nums"
                    class="btn btn-outline-primary p-l-15 d-flex align-items-center" variant="outline-primary"
                    @click="AddOtherProductName"
                     v-bind:t_label="'EMPBE_Product_info_add_Other_Name'">
                    <feather type="plus-circle"> </feather>
                    &nbsp; {{$t('lbl_EMPBE_ProductInfo_BasicInfo_AddOtherProductButton')}}
                </b-button>

  </div>
</template>
<script>
import ProductFieldApprovalResults from "../ProductFieldApprovalResults.vue";

export default {
    components: { ProductFieldApprovalResults },
    props: ["value",'nums',"supplierId","ProductId"],
    data(){
        return{
            temp_Value:this.value,
            cdnURL:"https://cdn.adsalecdn.com/EMP/Backend/svg/CompanyInfo/",
            Init_Temp:
            {
                productId: this.ProductId,
                nameT: "",
                nameE: "",
                ridE: undefined,
                ridT: undefined,
                orderid: undefined
            }
        }
    },
    watch:{
      value() {
          this.temp_Value = this.value;
      },
      temp_Value: {
            handler() 
            {
                this.$emit("input",this.temp_Value);

            },deep:true
        },
    },
    computed: {

    },
    methods: {
      otherNameRid(item, lang) {
        if (!item) return undefined;
        if (lang === 'E') {
          return item.ridE ?? item.RidE ?? item.RID_E ?? undefined;
        }
        return item.ridT ?? item.RidT ?? item.RID_T ?? undefined;
      },
      AddOtherProductName()
      {
        var newTemp = JSON.parse(JSON.stringify(this.Init_Temp));
        newTemp.orderId = this.temp_Value.length;
        this.temp_Value.push(newTemp);
      },
      DelOtherProductName(index)
      {
        this.temp_Value.splice(index,1);
      }
    }

}
</script>
<style lang="scss" scoped>
.OtherProductNameBody{
  .OtherProductName_nav
  {
    display: flex;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    margin-bottom: 18px;
    width: 100%;
    .OtherProductName_block
    {
      width: 100%;
      padding: 24px;
      border-radius: 16px;
      border: 1px solid var(--outline-10, rgba(0, 0, 0, 0.10));
    }
  }
}
</style>
